import React, { useState, Dispatch, SetStateAction, useEffect } from "react";
import styled from "styled-components";
import DropDown, { OptionType } from "../../../../../Filters/DropDown";
import { ModalLabel } from "../../../../Users/UserDetail/CommentModal/TargetContainer";
import { ModalRow } from "../../../../Users/UserDetail/BlackListModal/BlackListModal";
import { Input } from "../../../../../Input/Input";
import Flex from "../../../../../DefaultStyles/Flex";
import ConfirmBtn from "../../../../../Button/ConfirmBtn";
import { useApi } from "../../../../../../hooks/useApi";
import Loader from "../../../../../DefaultStyles/Loader";
import { toast } from "react-toastify";

interface PopupReasonSectionProps {
  reasonDropdown: OptionType;
  setReasonDropdown: Dispatch<SetStateAction<OptionType>>;
  modalType?: string;
  setCustomReasonId: Dispatch<SetStateAction<number>>;
}

export default function PopupReasonSection({
  reasonDropdown,
  setReasonDropdown,
  modalType,
  setCustomReasonId,
}: PopupReasonSectionProps) {
  const [addPopupType, setAddPopupType] = useState(false);
  const [customReason, setCustomReason] = useState("");
  const [getTypeList, setGetTypeList] = useState(false);
  const [typeOptionList, setTypeOptionList] = useState<OptionType[]>([]);

  // 팝업 사유 추가
  const { response, loading, error } = useApi({
    method: "post",
    url: addPopupType ? `popup/type` : undefined,
    data: {
      name: customReason,
    },
  });

  // 팝업 사유 조회
  const {
    response: typeRes,
    error: typeError,
    loading: typeLoading,
  } = useApi({
    method: "get",
    url: getTypeList ? `popup/type` : undefined,
  });

  useEffect(() => {
    if (response?.status === 201) {
      toast.success("팝업 사유를 추가했습니다.");
      setCustomReasonId(response?.data?.id);
    }
  }, [response]);

  useEffect(() => {
    const li: OptionType[] = [];

    if (typeRes?.status === 200) {
      if (typeRes?.data?.length > 0) {
        typeRes?.data?.forEach((a: any) =>
          li.push({
            value: `${a.id}`,
            label: `${a.name}`,
          })
        );

        const customLi = [...li, { value: "custom", label: "사유 추가" }];

        setTypeOptionList(customLi);
      }
    }
  }, [typeRes]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "팝업 사유를 추가하는 데에 실패하였습니다.");
    }
  }, [error]);

  useEffect(() => {
    if (typeError) {
      toast.error(
        typeError?.data ?? "팝업 사유 리스트를 가져오는 데에 실패하였습니다."
      );
    }
  }, [typeError]);

  return (
    <ModalRow style={{ alignItems: "flex-start" }}>
      <ModalLabel>팝업 사유</ModalLabel>

      <ModalColumn>
        <>
          {modalType === "view" ? (
            <Input value={reasonDropdown?.label} readOnly />
          ) : (
            <div onClick={() => setGetTypeList(true)}>
              <DropDown
                optionList={typeOptionList}
                dropdownValue={reasonDropdown}
                setDropDownValue={setReasonDropdown}
                boxWidth={230}
              />
            </div>
          )}
        </>

        {reasonDropdown?.value === "custom" && (
          <Flex gapSize={10} style={{ marginTop: 12 }}>
            <Input
              placeholder="직접 입력"
              value={customReason}
              onChange={(e) => setCustomReason(e.target.value)}
            />

            <ConfirmBtn
              btnColor="mint"
              btnText="추가"
              btnClickEvent={() => setAddPopupType(true)}
            />
          </Flex>
        )}
      </ModalColumn>

      {(loading || typeLoading) && <Loader />}
    </ModalRow>
  );
}

const ModalColumn = styled.div`
  width: auto;
`;
